// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-timeline[data-v-484a211f]{list-style:none;position:relative}[dir] .app-timeline[data-v-484a211f]{padding:0;margin:0}[dir=ltr] .app-timeline[data-v-484a211f]{margin-left:1rem}[dir=rtl] .app-timeline[data-v-484a211f]{margin-right:1rem}", ""]);
// Exports
module.exports = exports;
